import { UpperCasePipe } from '@angular/common';
import { Component, OnInit, inject, output, DestroyRef, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IAppConfig } from '@warema/shared/models';
import { WaremaHeaderMenu, WaremaHeaderMenuItem, WaremaHeaderMenuHeadline } from '@warema/warema-ui-angular';
import { filter } from 'rxjs';
import { SharedHeaderSubmenuLanguageComponent } from '../shared-header-submenu-language/shared-header-submenu-language.component';
import { SharedHeaderSubmenuToolsComponent } from '../shared-header-submenu-tools/shared-header-submenu-tools.component';

@Component({
    selector: 'warema-shared-header-menu',
    imports: [
        WaremaHeaderMenu,
        WaremaHeaderMenuItem,
        WaremaHeaderMenuHeadline,
        TranslatePipe,
        SharedHeaderSubmenuLanguageComponent,
        SharedHeaderSubmenuToolsComponent,
        UpperCasePipe,
    ],
    templateUrl: './shared-header-menu.component.html',
    styleUrl: './shared-header-menu.component.scss',
})
export class SharedHeaderMenuComponent implements OnInit {
    public readonly translateService = inject(TranslateService);
    private readonly _router = inject(Router);
    private readonly _destroyRef = inject(DestroyRef);

    public readonly appName = input.required<'warema-collection-assistant' | 'warema-designer-web' | 'warema-plus'>();

    public readonly toolname = input('');

    public readonly hideLanguage = input(false);

    public readonly version = input('');

    public readonly headerName = input('');

    public readonly showAppSpecificMenu = input(false);

    public readonly showCountryMenu = input(true);

    public readonly showLoginControls = input(true);

    public readonly showWaremaAGB = input(false);

    public readonly hideShopLinks = input(false);

    public readonly isLoggedIn = input(false);

    public readonly tenantConfigSettings = input<IAppConfig | null>(null);

    public readonly login = output<boolean>();
    public readonly logout = output<boolean>();
    public readonly clickUrl = output<[string, boolean]>(); // [url, openInNewTab]
    public readonly clickRouteRedirect = output<string>();
    public readonly setLanguage = output<string>();

    public firstRouteSegment = '';

    public ngOnInit(): void {
        this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntilDestroyed(this._destroyRef),
            )
            .subscribe((event: NavigationEnd) => {
                const routeSegments = event.url.replace('/', '').split('/');
                this.firstRouteSegment = routeSegments[0];
            });
    }
}
